<template>
    <div class="candy-option">
        <a @click.prevent="m_add_candy()" :class="[{ 'ticket-candy__price-selected': m_get_ticket_candy_qty() > 0 }, m_get_class_for_option()]" :alt="p_buyoption.strDescription" href="#">
            <div>
                <span class="ticket-price-before" v-if="m_validate_show_price_before()">${{ p_candy.PercentDiscount == 0 ? (p_candy.SalePrice / 100).toLocaleString('es-AR') : p_candy.SalePrice }}&nbsp;</span>
                <span v-html="m_total()"></span>
                <small v-if="$root.d_show_promotion_desc && p_buyoption.intPromoId != 0" class="promo_desc">{{ p_buyoption.strDescription }}</small>
            </div>
        </a>
        <transition name="slide-fade">
            <div v-if="transitionState" class="agregado">
                <span>AGREGADO</span>
            </div>
        </transition>
    </div>
</template>

<script>
import $ from "jquery";
import moment from "moment";

export default {
    name: 'buyoption',
    data() {
        return {
            transitionState: false,
        };
    },
    props: {
        p_candy: { type: Object, default: () => null },
        p_buyoption: { type: Object, default: () => null }
    },
    methods: {
        m_add_candy: function () {
            var isAdd = this.$root.m_add_candy(this.p_candy.strMCode, this.p_candy.strBarcode, this.p_buyoption.intRecogId, this.p_buyoption.intPromoId);

            if (isAdd) {
                // Establecer el estado de la transición en true para mostrar la transición
                this.transitionState = true;

                // Después de un segundo, restablecer el estado de la transición a false para ocultar la transición
                setTimeout(() => {
                    this.transitionState = false;
                }, 1000);
            }
        },
        m_get_class_for_option: function () {
            var className = "";
            var hasPoints = false;

            this.p_buyoption.lstBalances.forEach(balance => {
                if (balance.intPoints > 0) {
                    hasPoints = true;
                }
            });

            if (this.p_buyoption.intValue > 0) {
                if (hasPoints) {
                    //Pesos y Puntos
                    className = "pesospuntos";
                }
                else {
                    //Solo Pesos
                    className = "pesos";
                }
            }
            else {
                if (hasPoints) {
                    //Solo Puntos
                    className = "puntos";
                }
                else {
                    //Pesos
                    className = "pesos";
                }
            }

            return className;
        },
        m_total: function () {
            var price = "";
            var balances = "";
            var hasPoints = false;

            if (this.p_buyoption.intValue > 0) {
                price += `<span class="ticket-price-now">$${((this.p_buyoption.intValue * this.p_buyoption.intButtonQty) / 100).toLocaleString('es-AR')}</span>`;
            }

            if (this.p_buyoption.lstBalances.length == 1) {
                this.p_buyoption.lstBalances.forEach(balance => {
                    if (balance.intPoints > 0) {
                        hasPoints = true;
                        balances += `<span class="ticket-price-now">${balance.intPoints.toLocaleString('es-AR')}</span>&nbsp;<small class="ticket-price-span">${this.m_get_balance_name(balance.enuPointsType, balance.intBalanceId, (balance.intPoints > 1))}</small>`;
                    }
                });
            }

            if (this.p_buyoption.lstBalances.length > 1) {
                this.p_buyoption.lstBalances.forEach(balance => {
                    if (balance.intPoints > 0) {
                        hasPoints = true;

                        if (balances.length > 0) {
                            balances += " + ";
                        }

                        balances += `&nbsp;<small class="ticket-price-span">${balance.intPoints.toLocaleString('es-AR')} ${this.m_get_balance_name(balance.enuPointsType, balance.intBalanceId, (balance.intPoints > 1))}</small>`;
                    }
                });
            }

            if (!hasPoints && this.p_buyoption.intValue == 0) {
                price = '$0';
            }

            if (hasPoints && this.p_buyoption.intValue > 0) {
                price += ' + ';
            }

            var priceDesc = "";

            if (this.$root.d_member && this.$root.d_member.intLoyaltyLevel > 1 && this.p_buyoption.intType == 3 && this.p_buyoption.intRecogId != 0 && this.p_buyoption.intPromoId == 0) {
                priceDesc = `&nbsp;<span class="ticket-price-span">PRECIO CINE FAN</span>`;
            }
            else {
                /*if (this.m_validate_show_price_before()) {
                    priceDesc = `&nbsp;<span class="ticket-price-span">PRECIO WEB</span>`;
                }*/
            }

            return price + balances + priceDesc;
        },
        m_get_ticket_candy_qty: function () {
            return this.$root.m_get_ticket_candy_qty(this.p_candy.strMCode, this.p_candy.strBarcode, this.p_buyoption.intRecogId, this.p_buyoption.intPromoId);
        },
        m_validate_show_price_before() {
            var resp = false;

            if (this.p_buyoption.intValue == 0)
                return false;

            if (this.p_buyoption.intType == 3) {
                if ((this.p_buyoption.intRecogId != 0 && this.p_candy.SalePrice > this.p_buyoption.intValue)) {
                    resp = true;
                }
                else if ((this.p_buyoption.intPromoId != 0 && this.p_candy.SalePrice > this.p_buyoption.intValue)) {
                    resp = true;
                }
                else if (this.p_candy.PercentDiscount != 0 && this.p_candy.SalePrice * 100 > this.p_buyoption.intValue) {
                    resp = true;
                }
            }

            return resp;
        },
        m_get_balance_name: function (enuPointsType, intBalanceId, plural) {
            return this.$root.m_get_balance_name(enuPointsType, intBalanceId, false, plural);
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/BuyOption.vue